/* Pick-or-add a VEHICLE of the chosen product (teams-and-products.md
   TP4/TP8). Only that product's vehicles are offered — two products may
   use the same vehicle name for different purposes. Adding one from the
   form waits for an Admin's review (TP5). Optional: none is "not
   recorded". */
import type { JSX } from "react";
import type { Vehicle } from "../../../shared/products";
import { postVehicle } from "./api";
import type { FieldHelp } from "./form-help";
import { PickOrAdd } from "./PickOrAdd";

export function VehiclePicker({
  label,
  productId,
  vehicles,
  value,
  onChange,
  onAdded,
  disabled = false,
  help,
}: {
  label: string;
  productId: string;
  vehicles: Vehicle[];
  value: string;
  onChange: (id: string) => void;
  onAdded: (vehicle: Vehicle) => void;
  disabled?: boolean;
  help?: FieldHelp;
}): JSX.Element {
  return (
    <PickOrAdd
      label={label}
      noun="vehicle"
      items={vehicles.filter((v) => v.productId === productId)}
      value={value}
      onChange={onChange}
      onAdd={(name) => postVehicle(productId, name)}
      onAdded={onAdded}
      disabled={disabled}
      testId="vehicle-picker"
      help={help}
    />
  );
}
